// extracted by mini-css-extract-plugin
export default {"me":"index_me__DNmjB","card":"index_card__m8HFY","nav":"index_nav__p4Hst"};